import { actionTypes } from '@reveni-io/reveni-ui'

export const getNewRequestedProducts = items => {
  return items.reduce((total, item) => {
    let count = 0

    if (item?.actionType !== actionTypes.refund) {
      count += 1
    }

    const extraProductsCount = item?.extraProducts?.length || 0
    count += extraProductsCount

    return total + count
  }, 0)
}
